import React from 'react'
import ReportStandardUserListMobileTab from './ReportStandardUserListMobileTab'
import { buildReportDeliveriesUserMobileCardSections } from './reportDeliveriesUserMobileCardModel'

export default function ReportDeliveriesMobileTab(props) {
  return (
    <ReportStandardUserListMobileTab {...props} buildCardSections={buildReportDeliveriesUserMobileCardSections} />
  )
}
